import * as reportingAuditActions from '../reporting-audit.actions';

/**
 * @const {object}
 * @memberOf module:Reporting
 */
export const reportingAuditGenerate = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $scope, $rootScope, Notifier) {
        const unsubscribe = $ngRedux.connect(({ reporting }) => ({
            auditReport: reporting.auditReport
        }), {
            ...reportingAuditActions
        })(this);

        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.identifier = 'app.reporting.audit.generate';
        }

        this.generateReport = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.generateAuditReportForm');
            if (this.auditReport.location) {
                if (this.generateAuditReportForm.$valid) {
                    this.generateAuditReport(this.auditReport).then(() => {
                        Notifier.success('New audit report has been generated successfully');
                        resetForm();
                    }).catch(() => {
                        Notifier.error('System Error!');
                    });
                } else {
                    Notifier.error('Please fill in start and end date');
                }
            } else {
                 Notifier.error('Please select Head Office or Site Location');
            }
        }

        const resetForm = () => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', '$ctrl.generateAuditReportForm');
            this.generateAuditReportForm.$setPristine();
            this.generateAuditReportForm.$setUntouched();
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
        }
    },
    template: require('./reporting-audit-generate.html')
};
